import axios from "axios";
import { ACTIVE_ORG_COOKIE_NAME } from "@/shared/constants";

/** The API host that serves a given AOC host: aoc.example.com -> api.example.com.
 *  Exported because the public advisor pages call the backend without a token
 *  and so cannot go through the authenticated instance below. */
export const getBackendHost = (currentHost: string): string =>
  currentHost.replace(/^aoc\./, 'api.');

export const authenticatedBitswanBackendInstance = async (
  headers: Record<string, string> = {},
) => {
  const apiToken = localStorage.getItem('access_token');

  const activeOrgId = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${ACTIVE_ORG_COOKIE_NAME}=`))
    ?.split("=")[1];

  const currentHost = window.location.hostname;
  const protocol = "https:";
  const backendHost = getBackendHost(currentHost);
  const baseURL = `${protocol}//${backendHost}/api/frontend`;
  
  if (!apiToken) {
    console.error("No access token available for API calls");
  }

  return axios.create({
    baseURL: baseURL,
    headers: {
      Authorization: `Bearer ${apiToken}`,
      "Content-Type": "application/json",
      // Org-scoped endpoints refuse a request that does not say which
      // organisation it is for. Callers that know better still win: `headers`
      // is spread last.
      ...(activeOrgId ? { "X-Org-Id": activeOrgId } : {}),
      ...headers,
    },
  });
};